/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials, FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentialsFromJSONTyped, FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentialsToJSON, } from './FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials';
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestEmailCredentialsFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestEmailCredentialsFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestEmailCredentialsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials(json)) {
        return FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentialsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestEmailCredentialsToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestEmailCredentialsToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestEmailCredentialsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials(value)) {
        return FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentialsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestEmailCredentials.js.map